import { Card, Row, Button, message, Spin } from "antd";
import { useState, useEffect } from "react";
import HTTPClient from "../../../utils/HTTPClient";
import { useTranslation } from "react-i18next";

import { useNavigate } from "react-router-dom";

const Builder = () => {
    const navigate = useNavigate();

    const { t } = useTranslation();

    return (
        <Card
            bordered={true}
            style={{
                width: "100%",
                borderRadius: "10px",
                marginTop: "20px",
            }}>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "250px",
                    justifyContent: "space-between",
                }}>
                <div>
                    <Row
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",
                            alignItems: "center",
                        }}>
                        <img
                            src={"/template-create.png"}
                            alt={"Builder"}
                            style={{ width: "200px", height: "auto" }}
                        />
                    </Row>
                </div>

                <Button
                    type="primary"
                    style={{ bottom: "0", width: "100%", fontWeight: "bold" }}
                    onClick={() => {
                        navigate("/pro/builder/create");
                    }}>
                    {t("home.builder_button")}
                </Button>
            </div>
        </Card>
    );
};
export { Builder };
